// Belt-and-suspenders for the socialproapp.com -> catchment.software move:
// the CloudFront redirect and the SW-update fixes both depend on a stuck
// browser ever making a fresh request in the first place. If one of them
// eventually does load THIS bundle under an old host anyway (a slow SW
// update, a manual hard refresh, whatever finally got it unstuck), don't
// wait for React to mount and the rest of the app to notice — redirect
// synchronously, before any API call or Amplify setup can run against
// config the app never intended for this host.
const REDIRECT_HOSTS: Record<string, string> = {
  "delta.socialproapp.com": "delta.catchment.software",
  "dev.socialproapp.com": "dev.catchment.software",
  "goodman.socialproapp.com": "goodman.catchment.software",
  "kapitol.socialproapp.com": "kapitol.catchment.software",
  "multiplex.socialproapp.com": "multiplex.catchment.software",
  "portal.socialproapp.com": "au.catchment.software",
  "sec.socialproapp.com": "sec.catchment.software",
  "symal.socialproapp.com": "symal.catchment.software"
};

const target = REDIRECT_HOSTS[window.location.hostname];

// index.tsx checks this to skip mounting the app entirely once a redirect
// is underway, rather than rendering it for the moment before navigation
// actually takes effect.
export const isRedirectingToNewDomain = Boolean(target);

if (target) {
  window.location.replace(
    `https://${target}${window.location.pathname}${window.location.search}`
  );
}
